import { Routes } from '@angular/router';
import { ImpactAssessmentComponent } from '..';
import { ImpactOutcomeComponent } from './impact-outcome/impact-outcome.component';
import { ImpactAssessmentDetailsComponent } from './impact-assessment-details/impact-assessment-details.component';
import { ImpactAssessmentSummaryComponent } from './impact-assessment-summary/impact-assessment-summary.component';
import { ImpactAssessmentDashboardComponent } from './impact-assessment-dashboard/impact-assessment-dashboard.component';
import { ImpactAssessmentDashboard2Component } from './impact-assessment-dashboard2/impact-assessment-dashboard2.component';

export const ImpactAssessmentRoutes: Routes = [{
    path: '',
    component: ImpactAssessmentComponent,
    children: [
        {
            path: 'summary',
            component: ImpactAssessmentSummaryComponent
        },
        {
            path: 'complete',
            component: ImpactAssessmentSummaryComponent
        },
        {
            path: 'details/:filter/:id',
            component: ImpactAssessmentDetailsComponent
        },
        {
            path: 'details/:filter/:templateNo/:id',
            component: ImpactAssessmentDetailsComponent
        },
        {
            path: 'dashboard',
            component: ImpactAssessmentDashboardComponent
        },
        // New route without requiring login
        // {
        //     path: 'public-details/:filter/:id',
        //     component: ImpactAssessmentDetailsComponent
        // }
        {
            path: 'dashboard2',
            component: ImpactAssessmentDashboard2Component
        },
    ]
}];
